/**
 * @file 加载中状态
 * @author wangzhuang
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './index.less';

export default class Loding extends Component {
    static propTypes = {
        style: PropTypes.object, // 透传样式
        type: PropTypes.bool, // 判断加载中or没有更多
        isLoad: PropTypes.bool, // 是否继续回调
        callbackFn: PropTypes.func // 滚动条到指定位置的回调
    };

    componentDidMount() {
        window.addEventListener('scroll', () => this.loadingMore());
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', () => this.loadingMore());
    }

    loadingMore() {
        const lodingBox = this.lodingBox;
        const {callbackFn, isLoad} = this.props;
        let docScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        let clientHeight = document.documentElement.clientHeight;
        if (lodingBox) {
            if ((docScrollTop + clientHeight) > lodingBox.offsetTop && isLoad) {
                callbackFn && callbackFn();
            }
        }
    }

    render() {
        const {type, style} = this.props;
        return (
            <div className={'loading-box'} style={style} ref={el => this.lodingBox = el}>
                {
                    type ? <div className={'loding-btn'}></div>
                        : <div className={'loading pr'}>
                            <div className={'conter'}>
                                没有更多文章
                            </div>
                        </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Loading/index.js